// import axios from "axios"
// export default function dlEventCheck(eventname, acquisitionpoint) {
//   try {
//     let result = dataLayer.find(function(obj) {
//       return (
//         obj["event"] === eventname &&
//         obj["formId"].indexOf(acquisitionpoint) > -1
//       );
//     });
//     return result !== undefined;
//   } catch (err) {
//     return true;
//   }
// }

export default function getLGAPI() {
  var api =
    /dev|qa|localhost/.test(document.location.hostname) == true
      ? "https://leadgatewayqa.uti.edu/api/"
      : "https://utileadgateway.uti.edu/api/"
  return api
}

// export function getIP() {
//   axios
//     .get(`https://api.ipify.org?format=json`)
//     .then(response => {
//       //console.log(response)
//       //console.log(JSON.parse(response.data));
//       //console.log(`IP is,`, response.data.ip)
//       return response.data.ip
//     })
//     .catch(function(error) {
//       // handle error
//       console.log(error)
//     })
  //getIp: function() {
  //         return new Promise(function (resolve, reject) {
  //             if (typeof jQuery !== 'undefined') {
  //                 $(function () {
  //                     try {
  //                         $.getJSON('https://api.ipify.org?format=jsonp&callback=?',
  //                             function (JSON) {
  //                                 resolve(JSON.ip);
  //                             }
  //                         );
  //                     } catch (err) { reject; }
  //                 });
  //             }
  //         });
  //     },

